import { render, staticRenderFns } from "./AgregarImagenes.vue?vue&type=template&id=51e9a20d"
import script from "./AgregarImagenes.vue?vue&type=script&lang=js"
export * from "./AgregarImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports